import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/forumbee': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35 239.7 35 256.4 37 272.4 40.5 149 87.5 51.9 186 5.8 309.7zM398.7 120.5C385 103 369 87.8 350.9 75.2 201.3 119.5 84.6 237.3 41.2 387.2 53.7 405.3 69.2 422.8 86.4 436.2 129.5 284.9 247.6 164.5 398.7 120.5zM414.5 373.2C429.7 348.1 439.9 319.5 444 290.4 364.6 333.3 299 401 256.4 480.7 286.4 476.3 315.3 465.4 341 449.4 376 462.5 411.9 473.7 448 483 438.7 446.5 427.6 408.5 414.5 373.2zM444.2 227.7C441.6 208.2 436.3 189 428.4 170.9 290.5 216.7 182 327.5 137.1 466 155.2 473.6 174.1 478.5 193.7 481.2 240 367.1 330.5 274.4 444.2 227.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/forumbee.js
// module id = IniQ
// module chunks = 144